import { render } from "./BlockNode.vue?vue&type=template&id=156b0e94&ts=true"
import script from "./BlockNode.vue?vue&type=script&lang=ts"
export * from "./BlockNode.vue?vue&type=script&lang=ts"

import "./BlockNode.vue?vue&type=style&index=0&id=156b0e94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__